import React from 'react';
import Card from 'reactstrap/lib/Card';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { renderSocialLinks } from 'site-modules/shared/components/footer/footer';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';
import { EmbeddedYoutube } from 'site-modules/shared/components/video/embedded-youtube/embedded-youtube';
import { Link } from 'site-modules/shared/components/link/link';

const VIDEO_ID = '1aq5T1GCyOA';
const VIDEO_TITLE = 'Edmunds HQ | By the Numbers';

const ARTICLE_PHOTO = '/img/about/profile-history.jpg';
const ARTICLE_TITLE = 'Company Profile and History';

export function EdmundsUniverse() {
  return (
    <Card className="edmunds-universe p-1 p-lg-1_5">
      <div className="heading-3 mb-1_5">Edmunds Universe</div>
      <div className="text-gray-darker mb-0_5">Follow us:</div>
      <ul className="social-links d-flex list-unstyled size-20 m-0">{renderSocialLinks()}</ul>
      <hr className="my-1_5 w-100" />
      <div className="mb-1_5">
        <EmbeddedYoutube
          creativeId="universe-video"
          videoTitle={VIDEO_TITLE}
          videoId={VIDEO_ID}
          videoAspectRatio="16:9"
        />
        <div className="text-center heading-5 mt-0_5">{VIDEO_TITLE}</div>
      </div>
      <Link to="/about/profile.html" className="text-center text-primary-darker d-block">
        <AspectRatioContainer aspectRatio="52:17" className="mb-0_5">
          <img src={getStaticImageUrl(ARTICLE_PHOTO)} alt={ARTICLE_TITLE} />
        </AspectRatioContainer>
        Company Profile and History
      </Link>
    </Card>
  );
}
